import type { Employee } from '@/classes/Employee'
import type { InjectionKey } from 'vue'

export const authenticateEmployeeKey = Symbol() as InjectionKey<
  (
    employee: Employee,
    noPinChange?: boolean,
  ) => Promise<{ success: boolean; pin: string }>
>

export const selectEmployeeKey = Symbol() as InjectionKey<
  (
    employees: Employee[],
    customTitle?: string,
    customPrompt?: string,
    customStatusMessage?: string,
  ) => Promise<Employee | null>
>
